/**
 * All available toolbar tools
 */
export const ALL_TOOLS = [
  "headings",
  "bold",
  "italic",
  "link",
  "color",
  "highlight",
  "align",
  "strike",
  "lists",
  "blockquote",
  "code",
  "codeblock",
  "horizontalrule",
  "image",
  "video",
  "table",
];

/**
 * Tools that move to overflow menu based on editor size
 * - full: all tools stay in main toolbar
 * - big: only strike/blockquote/code/codeblock/horizontalrule go to ···
 * - medium: headings/align/image/table/+ overflow go to ···
 * - small: headings/align/lists/image/table/+ overflow go to ···
 */
export const SIZE_OVERFLOW = {
  full: new Set([]),
  big: new Set(["strike", "blockquote", "code", "codeblock", "horizontalrule"]),
  medium: new Set([
    "headings",
    "align",
    "image",
    "video",
    "table",
    "strike",
    "blockquote",
    "code",
    "codeblock",
    "horizontalrule",
  ]),
  small: new Set([
    "headings",
    "align",
    "lists",
    "image",
    "video",
    "table",
    "strike",
    "blockquote",
    "code",
    "codeblock",
    "horizontalrule",
  ]),
};

/**
 * Text color presets for color picker
 */
export const COLOR_PRESETS = [
  "#000000",
  "#374151",
  "#6B7280",
  "#EF4444",
  "#F97316",
  "#EAB308",
  "#22C55E",
  "#14B8A6",
  "#3B82F6",
  "#6366F1",
  "#A855F7",
  "#EC4899",
];

/**
 * Highlight color presets for highlight picker
 */
export const HIGHLIGHT_PRESETS = [
  "#FEF08A",
  "#FDE68A",
  "#FCA5A5",
  "#FDBA74",
  "#BBF7D0",
  "#A7F3D0",
  "#BAE6FD",
  "#C7D2FE",
  "#E9D5FF",
  "#FBCFE8",
  "#D1FAE5",
  "#F3F4F6",
];

/**
 * Secondary tools that typically appear in overflow menu
 */
export const SECONDARY_TOOLS = [
  "strike",
  "blockquote",
  "code",
  "codeblock",
  "horizontalrule",
];
